import MainPageBancoDados from '@/screens/bancoDados/MainPage'
import GlebaImovel from '@/screens/bancoDados/gleba/GlebaImovel'
import CadastroGleba from '@/screens/bancoDados/gleba/CadastroGleba'
import EditarGleba from '@/screens/bancoDados/gleba/EditarGleba'
import ConsultaProcessosAntigos from '@/screens/bancoDados/consultaProcessosAntigos/ConsultaProcessosAntigos'

const bancoDeDados = [
  {
    path: '/bancoDados',
    name: 'bancoDados',
    component: MainPageBancoDados,
    meta: {
      isPublic: false
    },
    children: [
      {
        path: '/bancoDados/gleba',
        name: 'bancoDados/gleba',
        component: GlebaImovel,
        meta: {
          isPublic: false,
          routeGroup: 'GLEBA'
        }
      },
      {
        path: '/bancoDados/gleba/cadastro',
        name: 'bancoDados/gleba/cadastro',
        component: CadastroGleba,
        meta: {
          isPublic: false,
          routeGroup: 'GLEBA'
        }
      },
      {
        path: '/bancoDados/gleba/editar',
        name: 'bancoDados/gleba/editar',
        component: EditarGleba,
        meta: {
          isPublic: false,
          routeGroup: 'GLEBA'
        }
      },
      {
        path: '/bancoDados/consultaProcessosAntigos',
        name: 'bancoDados/consultaProcessosAntigos',
        component: ConsultaProcessosAntigos,
        meta: {
          isPublic: false,
          routeGroup: 'CONSULTA_PROCESSOS_ANTIGOS'
        }
      }
    ]
  }
]

export default bancoDeDados



// WEBPACK FOOTER //
// ./src/router/bancoDeDados.js